import { DateI18N } from "@sundae/ui-toolkit";
import { FC, memo } from "react";
import { Trans } from "react-i18next";
import { useTasteTestContext } from "../../../../pages/TasteTestDetail/context";

const TasteTestDuration: FC = () => {
  const {
    state: { tasteTest },
  } = useTasteTestContext();

  if (tasteTest?.openDate && tasteTest?.endDate) {
    return (
      <Trans i18nKey="detail.duration" ns="taste-test">
        This Taste Test started on{" "}
        <DateI18N value={new Date(tasteTest.openDate.format)} size="xs" /> and will end on{" "}
        <DateI18N value={new Date(tasteTest.endDate.format)} size="xs" />.
      </Trans>
    );
  }

  return null;
};

export default memo(TasteTestDuration);
